import { Space } from "antd";
import Search from "antd/es/input/Search";
import { Link, useLocation } from "react-router-dom";
import AddIcon from "../../../assets/icons/AddIcon";
import ResourceTable from "../../../components/NP/Resource/ResourceTable";
import IconButton from "../../../components/common/IconButton";
import Subheader from "../../../components/ui/Subheader";
import { pathLink } from "../../../helpers/siteConfig";
import useDebounce from "../../../hooks/useDebounce";
import useTable from "../../../hooks/useTable";
import AdminLayout from "../../../layouts/AdminLayout";
import { useAppSelector } from "../../../store/store";
import { AddZero } from "../../../utils/number";
import { minutesToHours } from "../../../utils/time";

export default function Resource() {
  const { usersCount, loading, allUsers } = useAppSelector(
    (state) => state.resource
  );
  const { keyword, handleInputChange, handleEnterValue } = useDebounce();
  const { handleSetFirstPage, ...rest } = useTable();

  const location = useLocation();
  const path = pathLink(location.pathname, 1);

  // const handleSiteLocator = (value: string) => {
  //   console.log(`selected ${value}`);
  // };
  // const handleDateChange: DatePickerProps["onChange"] = (date, dateString) => {
  //   console.log(date, dateString);
  // };

  return (
    <AdminLayout title="PG Runner List" headerTitle="PG Runner">
      <section className="mt-7">
        <Subheader
          title="PG Runner List"
          subTitle={`Total PG Runner: ${AddZero(
            keyword && !loading ? allUsers?.length : usersCount?.totalUsers
          )}`}
        >
          <Space size="middle">
            {/* <Select
              showSearch
              placeholder="Select a person"
              optionFilterProp="children"
              onChange={handleSiteLocator}
              filterOption={selectSearchOption}
              defaultValue="Inactive Networks"
              className="min-w-[8rem]"
              options={[
                {
                  value: "Inactive Networks",
                  label: "Inactive Networks",
                },
                {
                  value: "Pending",
                  label: "Pending",
                },
              ]}
            />
            <DatePicker onChange={handleDateChange} /> */}
            <div className="text-header font-medium">
              Total Amount:{" "}
              <strong>{AddZero(usersCount?.totalAmount)} BDT</strong>
              <br />
              Total Work Time:{" "}
              <strong>
                {minutesToHours(usersCount?.totalMinutesOfWork)} min
              </strong>
            </div>
            <Search
              placeholder="Search by name"
              onSearch={(val) => {
                handleEnterValue(val);
                handleSetFirstPage(true);
              }}
              onChange={(val) => {
                handleInputChange(val);
                handleSetFirstPage(true);
              }}
              className="custom-search-input"
            />
            <Link to={`/${path}/resource/add-resource`}>
              <IconButton type="primary" nextIcon={<AddIcon />}>
                Add New
              </IconButton>
            </Link>
          </Space>
        </Subheader>

        <ResourceTable
          keyword={keyword}
          handleSetFirstPage={handleSetFirstPage}
          {...rest}
        />
      </section>
    </AdminLayout>
  );
}
